module.exports = __webpack_public_path__ + "img/nextshop-logo.df12fa21.svg";